import InviteFriendJumbotron from './InviteFriendJumbotron'

export default InviteFriendJumbotron
// eslint-disable-next-line import/export
export * from './InviteFriendJumbotron'
